<template>
    <div class="bax-banner-content d-flex align-items-end pb-0">
        <div class="container">
            <div class="bax-tab-wrap">
                <div class="tabs d-md-flex justify-content-md-between">
                    <div
                        v-for="(step, index) in steps"
                        :key="index"
                        data-v-46c7b794=""
                        class="tab-button"
                        v-bind:class="
                            [
                                (active == step.label ? 'tab-active' : ''),
                                (step.label < active ? 'tab-complete' : '')
                            ]
                        "
                    >
                        <a>
                            <span data-v-46c7b794="" class="tab-label">
                                Step {{ step.label }}
                            </span>
                            <span data-v-46c7b794="" class="tab-name">{{ step.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tpnMixin from '@/mixins/tpnMixin';

    export default {
    name: 'OrderSteps',
    mixins: [tpnMixin],
    props: {
        active: {
            required: true,
        },
        data() {
            return {
                open: false,
                randId: '',
                onHold: false,
            };
        },

    },
    data() {
        let returnsteps = [];
        if (this.isTPN()) {
            returnsteps = [
                {
                    label: 1,
                    name: 'Start Order',
                },
                {
                    label: 2,
                    name: 'Select Product',
                },
                {
                    label: 3,
                    name: 'Review and Complete',
                },
            ];
        } else {
            returnsteps = [
                {
                    label: 1,
                    name: 'Start Order',
                },
                {
                    label: 2,
                    name: 'Select Patient',
                },
                {
                    label: 3,
                    name: 'Drug Details',
                },
                {
                    label: 4,
                    name: 'Review and Complete',
                },
            ];
        }

        return {
            steps: returnsteps,
        };
    },
    mounted() {
        //
    },
};
</script>
